export const AuthApiService = {
  async login(email, password) {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({email, password}),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      if (data.token) {
        localStorage.setItem('token', data.token);
      }
      return data;
    } catch (error) {
      throw new Error('Login failed: ' + error.message);
    }
  },

  async getCurrentUser() {
    try {
      const response = await fetch('/api/auth/me', {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to get current user');
      }

      return await response.json();
    } catch (error) {
      throw new Error('Failed to get user info');
    }
  },

  async logout() {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      localStorage.removeItem('token');
    } catch (error) {
      throw new Error('Logout failed');
    }
  },

  getToken() {
    return localStorage.getItem('token');
  },

  isAuthenticated() {
    return !!this.getToken();
  }
};
